import React from 'react';
import loadable from '@loadable/component';

const ShutdownMessageModal = loadable(() =>
  import(/* webpackChunkName: "extra" */ './modal')
);

export default props => <ShutdownMessageModal {...props} />;
